
<div class="subscribers-page">

  <!-- TOOLBAR PRINCIPALE -->
  <div class="subscribers-toolbar">
    <div class="subscribers-toolbar-title">
      <div class="subscribers-title-icon">
        <i class="pi pi-users"></i>
      </div>

      <div>
        <h2>Gestione iscritti</h2>
        <p>Consulta e gestisci gli iscritti FAISA-CISAL</p>
      </div>
    </div>

    <div class="subscribers-toolbar-actions">
      <span class="p-input-icon-left subscribers-search">
        <i class="pi pi-search"></i>

        <input
          pInputText
          type="text"
          [(ngModel)]="search"
          placeholder="Cerca iscritto..."
          aria-label="Cerca iscritto"
        />
      </span>

      <p-button
        *ngIf="search"
        icon="pi pi-times"
        [outlined]="true"
        (onClick)="search = ''"
        pTooltip="Cancella ricerca"
      ></p-button>

      <p-button
        icon="pi pi-refresh"
        [outlined]="true"
        (onClick)="loadUsers()"
        pTooltip="Aggiorna elenco"
      ></p-button>

      <p-button
        *ngIf="hasModifyPermissions"
        icon="pi pi-plus"
        (onClick)="createNewSubscriber()"
        pTooltip="Nuovo iscritto"
      ></p-button>
    </div>
  </div>

  <!-- CONTATORI E FILTRI -->
  <div class="subscribers-statistics">

    <!-- PRIMA RIGA: TOTALE -->
    <div class="stat-card stat-card-total">
      <i class="pi pi-users"></i>

      <div>
        <span>Totale iscritti</span>
        <strong>{{ users.length }}</strong>
      </div>
    </div>

    <!-- SECONDA RIGA: INTERNI / ESTERNI -->
    <button
      type="button"
      class="stat-card stat-card-filter"
      [class.stat-card-active]="activeFilter === 'internal'"
      [attr.aria-pressed]="activeFilter === 'internal'"
      (click)="toggleFilter('internal')"
      pTooltip="Filtra gli iscritti interni"
    >
      <i class="pi pi-home"></i>

      <div>
        <span>Interni</span>
        <strong>{{ internal }}</strong>
      </div>

      <i
        class="pi pi-check stat-filter-check"
        *ngIf="activeFilter === 'internal'"
      ></i>
    </button>

    <button
      type="button"
      class="stat-card stat-card-filter"
      [class.stat-card-active]="activeFilter === 'external'"
      [attr.aria-pressed]="activeFilter === 'external'"
      (click)="toggleFilter('external')"
      pTooltip="Filtra gli iscritti esterni"
    >
      <i class="pi pi-globe"></i>

      <div>
        <span>Esterni</span>
        <strong>{{ external }}</strong>
      </div>

      <i
        class="pi pi-check stat-filter-check"
        *ngIf="activeFilter === 'external'"
      ></i>
    </button>

    <!-- TERZA RIGA: CONTRATTI -->
    <button
      type="button"
      class="stat-card stat-card-filter"
      [class.stat-card-active]="activeFilter === 'AT'"
      [attr.aria-pressed]="activeFilter === 'AT'"
      (click)="toggleFilter('AT')"
      pTooltip="Filtra gli iscritti con contratto AT"
    >
      <i class="pi pi-id-card"></i>

      <div>
        <span>Contratto AT</span>
        <strong>{{ contractAT }}</strong>
      </div>

      <i
        class="pi pi-check stat-filter-check"
        *ngIf="activeFilter === 'AT'"
      ></i>
    </button>

    <button
      type="button"
      class="stat-card stat-card-filter"
      [class.stat-card-active]="activeFilter === 'EX-COPIT'"
      [attr.aria-pressed]="activeFilter === 'EX-COPIT'"
      (click)="toggleFilter('EX-COPIT')"
      pTooltip="Filtra gli iscritti EX-COPIT"
    >
      <i class="pi pi-briefcase"></i>

      <div>
        <span>EX-COPIT</span>
        <strong>{{ contratEX }}</strong>
      </div>

      <i
        class="pi pi-check stat-filter-check"
        *ngIf="activeFilter === 'EX-COPIT'"
      ></i>
    </button>

  </div>

  <!-- LOADING ISCRITTI -->
  <div
    *ngIf="usersLoading"
    class="subscribers-loading"
    role="status"
    aria-live="polite"
  >
    <img
      src="assets/icons/loading-spinner.svg"
      alt="Caricamento iscritti"
      class="subscribers-loading-image"
    />

    <span>Caricamento iscritti in corso...</span>
  </div>

  <!-- INTESTAZIONE ELENCO -->
  <div
    *ngIf="!usersLoading"
    class="subscribers-section-heading"
  >
    <div>
      <h3>Elenco iscritti</h3>

      <p>
        {{ filteredUsers.length }}
        {{
          filteredUsers.length === 1
            ? 'iscritto visualizzato'
            : 'iscritti visualizzati'
        }}
      </p>
    </div>

    <button
      *ngIf="activeFilter"
      type="button"
      class="subscribers-clear-filter"
      (click)="clearFilter()"
    >
      <i class="pi pi-times"></i>
      <span>Rimuovi filtro: {{ activeFilterLabel }}</span>
    </button>
  </div>

  <!-- GRIGLIA SCHEDE -->
  <div
    *ngIf="!usersLoading"
    class="subscribers-grid"
  >

    <button
      type="button"
      class="subscriber-card"
      *ngFor="
        let subscriber of filteredUsers;
        trackBy: trackBySubscriber
      "
      (click)="openSubscriber(subscriber)"
    >
      <div class="subscriber-card-top">
        <div class="subscriber-avatar">
          <i class="pi pi-user"></i>
        </div>

        <span
          class="subscriber-type"
          [class.external]="subscriber.isExternal"
        >
          {{ subscriber.isExternal ? 'Esterno' : 'Interno' }}
        </span>
      </div>

      <div class="subscriber-card-name">
        <h4>
          {{ subscriber.name }}
          {{ subscriber.lastName }}
        </h4>
      </div>

      <div class="subscriber-card-details">
        <div class="subscriber-detail">
          <i class="pi pi-id-card"></i>

          <span>
            <small>Matricola</small>
            <strong>
              {{ subscriber.registerNumber || 'Non indicata' }}
            </strong>
          </span>
        </div>

        <div class="subscriber-detail">
          <i class="pi pi-briefcase"></i>

          <span>
            <small>Ruolo</small>
            <strong>
              {{ subscriber.role || 'Non indicato' }}
            </strong>
          </span>
        </div>

        <div class="subscriber-detail">
          <i class="pi pi-map-marker"></i>

          <span>
            <small>Sede</small>
            <strong>
              {{ subscriber.headquarter || 'Non indicata' }}
            </strong>
          </span>
        </div>
      </div>

      <div class="subscriber-card-footer">
        <span>Visualizza dettagli</span>
        <i class="pi pi-arrow-right"></i>
      </div>
    </button>

  </div>

  <!-- STATO VUOTO: MAI VISIBILE DURANTE IL LOADING -->
  <div
    class="subscribers-empty"
    *ngIf="!usersLoading && filteredUsers.length === 0"
  >
    <i class="pi pi-search"></i>

    <h3>Nessun iscritto trovato</h3>

    <p>
      Prova a modificare la ricerca oppure rimuovi
      il filtro selezionato.
    </p>

    <p-button
      *ngIf="search"
      label="Rimuovi ricerca"
      icon="pi pi-times"
      [outlined]="true"
      (onClick)="search = ''"
    ></p-button>

    <p-button
      *ngIf="activeFilter"
      label="Rimuovi filtro"
      icon="pi pi-filter-slash"
      [outlined]="true"
      (onClick)="clearFilter()"
    ></p-button>
  </div>

</div>

<!-- =====================================================
     DIALOG DETTAGLIO / MODIFICA / CREAZIONE
     MODIFICA: RIMOSSO IL PULSANTE "CHIUDI"
     ===================================================== -->

<p-dialog
  [(visible)]="subscriberDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [closable]="!savingSubscriber"
  [style]="{
    width: '720px',
    maxWidth: 'calc(100vw - 1rem)'
  }"
  styleClass="subscriber-detail-dialog"
  (onHide)="closeSubscriberDialog()"
>
  <ng-template pTemplate="header">
    <div class="subscriber-dialog-heading">
      <i
        class="pi"
        [ngClass]="
          isEditingSubscriber || isCreatingSubscriber
            ? 'pi-user-edit'
            : 'pi-user'
        "
      ></i>

      <div>
        <h2>
          {{
            isCreatingSubscriber
              ? 'Nuovo iscritto'
              : isEditingSubscriber
                ? 'Modifica iscritto'
                : 'Dettaglio iscritto'
          }}
        </h2>

        <p>
          {{
            isCreatingSubscriber
              ? 'Inserisci i dati del nuovo iscritto'
              : isEditingSubscriber
                ? 'Modifica i dati e salva le modifiche'
                : 'Visualizza le informazioni dell’iscritto'
          }}
        </p>
      </div>
    </div>
  </ng-template>

  <div
    class="subscriber-dialog-content"
    *ngIf="selectedSubscriber"
  >
    <div class="subscriber-form-grid">

      <!-- NOME -->
      <div class="subscriber-field">
        <label for="subscriber-name">Nome</label>

        <ng-container
          *ngIf="isEditingSubscriber; else nameReadonly"
        >
          <input
            id="subscriber-name"
            pInputText
            [(ngModel)]="selectedSubscriber.name"
            [disabled]="savingSubscriber"
          />
        </ng-container>

        <ng-template #nameReadonly>
          <div class="subscriber-readonly-value">
            {{ selectedSubscriber.name || 'Non indicato' }}
          </div>
        </ng-template>
      </div>

      <!-- COGNOME -->
      <div class="subscriber-field">
        <label for="subscriber-lastname">Cognome</label>

        <ng-container
          *ngIf="isEditingSubscriber; else lastNameReadonly"
        >
          <input
            id="subscriber-lastname"
            pInputText
            [(ngModel)]="selectedSubscriber.lastName"
            [disabled]="savingSubscriber"
          />
        </ng-container>

        <ng-template #lastNameReadonly>
          <div class="subscriber-readonly-value">
            {{ selectedSubscriber.lastName || 'Non indicato' }}
          </div>
        </ng-template>
      </div>

      <!-- MATRICOLA -->
      <div class="subscriber-field">
        <label for="subscriber-register">Matricola</label>

        <ng-container
          *ngIf="isEditingSubscriber; else registerReadonly"
        >
          <input
            id="subscriber-register"
            pInputText
            [(ngModel)]="selectedSubscriber.registerNumber"
            [disabled]="savingSubscriber"
          />
        </ng-container>

        <ng-template #registerReadonly>
          <div class="subscriber-readonly-value">
            {{
              selectedSubscriber.registerNumber ||
              'Non indicata'
            }}
          </div>
        </ng-template>
      </div>

      <!-- EMAIL -->
      <div class="subscriber-field">
        <label for="subscriber-email">Email</label>

        <ng-container
          *ngIf="isEditingSubscriber; else emailReadonly"
        >
          <input
            id="subscriber-email"
            pInputText
            type="email"
            [(ngModel)]="selectedSubscriber.email"
            [disabled]="savingSubscriber"
          />
        </ng-container>

        <ng-template #emailReadonly>
          <div class="subscriber-readonly-value">
            {{ selectedSubscriber.email || 'Non indicata' }}
          </div>
        </ng-template>
      </div>

      <!-- TELEFONO -->
      <div class="subscriber-field">
        <label for="subscriber-phone">Telefono</label>

        <ng-container
          *ngIf="isEditingSubscriber; else phoneReadonly"
        >
          <input
            id="subscriber-phone"
            pInputText
            type="tel"
            [(ngModel)]="selectedSubscriber.phone"
            [disabled]="savingSubscriber"
          />
        </ng-container>

        <ng-template #phoneReadonly>
          <div class="subscriber-readonly-value">
            {{ selectedSubscriber.phone || 'Non indicato' }}
          </div>
        </ng-template>
      </div>

      <!-- SEDE OPERATIVA -->
      <div class="subscriber-field">
        <label for="subscriber-headquarter">
          Sede operativa
        </label>

        <ng-container
          *ngIf="isEditingSubscriber; else headquarterReadonly"
        >
          <input
            id="subscriber-headquarter"
            pInputText
            [(ngModel)]="selectedSubscriber.headquarter"
            [disabled]="savingSubscriber"
          />
        </ng-container>

        <ng-template #headquarterReadonly>
          <div class="subscriber-readonly-value">
            {{
              selectedSubscriber.headquarter ||
              'Non indicata'
            }}
          </div>
        </ng-template>
      </div>

      <!-- RUOLO -->
      <div class="subscriber-field">
        <label>Ruolo</label>

        <ng-container
          *ngIf="isEditingSubscriber; else roleReadonly"
        >
          <p-dropdown
            [options]="roles"
            [(ngModel)]="selectedSubscriber.role"
            [disabled]="savingSubscriber"
            placeholder="Seleziona ruolo"
            [style]="{ width: '100%' }"
            appendTo="body"
          ></p-dropdown>
        </ng-container>

        <ng-template #roleReadonly>
          <div class="subscriber-readonly-value">
            {{
              selectedSubscriber.role ||
              'Non indicato'
            }}
          </div>
        </ng-template>
      </div>

      <!-- COMPARTO -->
      <div class="subscriber-field">
        <label>Comparto</label>

        <ng-container
          *ngIf="isEditingSubscriber; else sectorReadonly"
        >
          <p-dropdown
            [options]="sectors"
            [(ngModel)]="selectedSubscriber.sector"
            [disabled]="savingSubscriber"
            placeholder="Seleziona comparto"
            [style]="{ width: '100%' }"
            appendTo="body"
          ></p-dropdown>
        </ng-container>

        <ng-template #sectorReadonly>
          <div class="subscriber-readonly-value">
            {{
              selectedSubscriber.sector ||
              'Non indicato'
            }}
          </div>
        </ng-template>
      </div>

      <!-- TIPO CONTRATTO -->
      <div class="subscriber-field">
        <label>Tipo contratto</label>

        <ng-container
          *ngIf="isEditingSubscriber; else contractReadonly"
        >
          <p-dropdown
            [options]="typeContracts"
            [(ngModel)]="selectedSubscriber.typeContract"
            [disabled]="savingSubscriber"
            placeholder="Seleziona contratto"
            [style]="{ width: '100%' }"
            appendTo="body"
          ></p-dropdown>
        </ng-container>

        <ng-template #contractReadonly>
          <div class="subscriber-readonly-value">
            {{
              selectedSubscriber.typeContract ||
              'Non indicato'
            }}
          </div>
        </ng-template>
      </div>

      <!-- UTENTE ESTERNO -->
      <div class="subscriber-field subscriber-external-field">
        <label>Utente esterno</label>

        <ng-container
          *ngIf="isEditingSubscriber; else externalReadonly"
        >
          <p-toggleButton
            [(ngModel)]="selectedSubscriber.isExternal"
            [disabled]="savingSubscriber"
            onLabel="Sì"
            offLabel="No"
          ></p-toggleButton>
        </ng-container>

        <ng-template #externalReadonly>
          <div class="subscriber-readonly-value">
            <span
              class="subscriber-type"
              [class.external]="selectedSubscriber.isExternal"
            >
              {{
                selectedSubscriber.isExternal
                  ? 'Sì'
                  : 'No'
              }}
            </span>
          </div>
        </ng-template>
      </div>

      <!-- CODICE ESTERNO -->
      <div class="subscriber-field subscriber-field-full">
        <label for="subscriber-code">Codice esterno</label>

        <ng-container
          *ngIf="isEditingSubscriber; else codeReadonly"
        >
          <div class="subscriber-code-row">
            <input
              id="subscriber-code"
              pInputText
              [(ngModel)]="selectedSubscriber.externalCode"
              [disabled]="savingSubscriber"
            />

            <p-button
              *ngIf="hasModifyPermissions"
              icon="pi pi-refresh"
              [outlined]="true"
              [disabled]="savingSubscriber"
              (onClick)="regenerateDialogCode()"
              pTooltip="Genera un nuovo codice"
            ></p-button>
          </div>
        </ng-container>

        <ng-template #codeReadonly>
          <div class="subscriber-readonly-value">
            {{
              selectedSubscriber.externalCode ||
              'Non indicato'
            }}
          </div>
        </ng-template>
      </div>

    </div>
  </div>

  <!-- FOOTER DIALOG ISCRITTO -->
  <!-- Eliminato il pulsante "Chiudi". -->
  <!-- Rimangono i pulsanti per modificare, salvare ed eliminare. -->

  <ng-template pTemplate="footer">
    <div class="subscriber-dialog-footer">
      <div class="subscriber-dialog-actions">

        <p-button
          *ngIf="
            isEditingSubscriber &&
            !isCreatingSubscriber
          "
          label="Annulla modifica"
          icon="pi pi-undo"
          severity="secondary"
          [outlined]="true"
          [disabled]="savingSubscriber"
          (onClick)="cancelSubscriberEditing()"
          styleClass="subscriber-action-button"
          pTooltip="Annulla modifica"
        ></p-button>

        <p-button
          *ngIf="
            hasModifyPermissions &&
            !isEditingSubscriber &&
            !isCreatingSubscriber
          "
          label="Modifica"
          icon="pi pi-pencil"
          (onClick)="enableSubscriberEditing()"
          styleClass="subscriber-action-button"
          pTooltip="Modifica"
        ></p-button>

        <p-button
          *ngIf="
            hasModifyPermissions &&
            isEditingSubscriber
          "
          [label]="
            isCreatingSubscriber
              ? 'Crea iscritto'
              : 'Salva modifiche'
          "
          icon="pi pi-check"
          [disabled]="savingSubscriber"
          [loading]="savingSubscriber"
          (onClick)="saveDialogSubscriber()"
          styleClass="subscriber-action-button"
          [pTooltip]="
            isCreatingSubscriber
              ? 'Crea iscritto'
              : 'Salva modifiche'
          "
        ></p-button>

        <p-button
          *ngIf="
            hasModifyPermissions &&
            !isCreatingSubscriber &&
            !isEditingSubscriber
          "
          label="Elimina"
          icon="pi pi-trash"
          severity="danger"
          [outlined]="true"
          [disabled]="savingSubscriber"
          (onClick)="deleteSelectedSubscriber()"
          styleClass="subscriber-action-button"
          pTooltip="Elimina iscritto"
        ></p-button>

      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- =====================================================
     DIALOG SCELTA ESPORTAZIONE EXCEL
     MODIFICA: RIMOSSO IL PULSANTE "ANNULLA"
     ===================================================== -->

<p-dialog
  header="Esportazione Excel"
  [(visible)]="exportDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{
    width: '500px',
    maxWidth: 'calc(100vw - 1rem)'
  }"
>
  <div
    style="
      display: flex;
      flex-direction: column;
      gap: 1rem;
      padding: 0.5rem 0;
    "
  >
    <p
      style="
        margin: 0 0 0.25rem;
        color: #64748b;
        line-height: 1.5;
      "
    >
      Seleziona il tipo di elenco che desideri
      esportare in formato Excel.
    </p>

    <!-- SCELTA 1 -->
    <button
      type="button"
      (click)="exportConsegnaStrenne()"
      style="
        display: flex;
        align-items: center;
        gap: 1rem;
        width: 100%;
        padding: 1rem;
        border: 1px solid #bfdbfe;
        border-radius: 10px;
        background: #f8fbff;
        color: #12356f;
        text-align: left;
        cursor: pointer;
      "
    >
      <i
        class="pi pi-gift"
        style="
          font-size: 1.5rem;
          color: #3b82f6;
        "
      ></i>

      <span
        style="
          display: flex;
          flex-direction: column;
          gap: 0.35rem;
          min-width: 0;
        "
      >
        <strong style="font-size: 1rem;">
          Consegna strenne
        </strong>

        <small
          style="
            color: #64748b;
            line-height: 1.45;
          "
        >
          Sei colonne. Elenco raggruppato per città,
          poi per ruolo e ordinato per cognome.
        </small>
      </span>
    </button>

    <!-- SCELTA 2 -->
    <button
      type="button"
      (click)="exportListaConvenzioni()"
      style="
        display: flex;
        align-items: center;
        gap: 1rem;
        width: 100%;
        padding: 1rem;
        border: 1px solid #bfdbfe;
        border-radius: 10px;
        background: #f8fbff;
        color: #12356f;
        text-align: left;
        cursor: pointer;
      "
    >
      <i
        class="pi pi-file-excel"
        style="
          font-size: 1.5rem;
          color: #3b82f6;
        "
      ></i>

      <span
        style="
          display: flex;
          flex-direction: column;
          gap: 0.35rem;
          min-width: 0;
        "
      >
        <strong style="font-size: 1rem;">
          Lista convenzioni
        </strong>

        <small
          style="
            color: #64748b;
            line-height: 1.45;
          "
        >
          Quattro colonne. Esclude gli iscritti
          con ruolo Convenzione e ordina per cognome.
        </small>
      </span>
    </button>

  </div>

  <!-- Footer eliminato: la dialog si chiude con la X. -->
</p-dialog>

<!-- MENU RAPIDO -->
<p-speedDial
  [model]="items"
  showIcon="pi pi-chevron-up"
  hideIcon="pi pi-chevron-down"
  direction="up"
  type="linear"
></p-speedDial>
